import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeUnderscores',
    standalone: false
})
export class RemoveUnderscoresPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return '';
    }
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}